import React, { useEffect, useState, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import {
  Button,
  Paper,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
  IconButton,
  MenuItem,
  Grid,
  TextField
} from "@material-ui/core";


import ContactMailIcon from '@material-ui/icons/ContactMail';
import CloseIcon from '@material-ui/icons/Close';

import { PageContext } from "../../../contexts/PageContext";
import { UserContext } from "../../../contexts/UserContext";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  descriptionPaper: theme.descriptionPaper,
}));

export default function AssignAgentDialog(
  {
    credit,
    creditFunctions
  }) {
  const theme = useTheme();
  const classes = useStyles();
  let history = useHistory();

  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);

  const userContext = useContext(UserContext);
  const pageContext = useContext(PageContext);
  const [selectedUser, setSelectedUser] = useState(false);
  useEffect(() => {
    if (open) {
      // check agents loaded
      if (!users || users.length === 0) {
        getUsers();
      }
    }
  }, [open]);

  const getUsers = () => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/users`,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        // filter test accounts (id 1 - 6), only active agents can be assigned
        var newUsers = res.data.filter((user) => user.id > 6 && user.role === "agent" && user.active);
        // order by user.name
        newUsers.sort((a, b) => (a.name > b.name) ? 1 : -1);

        setUsers(newUsers);
      })
      .catch((err) => { console.log(err); });
  }

  const setCreditOwner = (user_id) => {
    // Die Übertragung zur Bank ist immer im Account des Agenten, daher muss diese mit dem neuen Agenten newu übertragen werden
    creditFunctions.resetExternalCreditIds();

    const saveData = { ...credit, user_id: user_id };
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${credit.id}`,
      data: saveData,
      method: 'put',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        pageContext.setInfoMessage("Dein Kreditantrag wurde erfolgreich an den Finanzierungsberater übergeben.");
        history.push("/finanzierungen/");
      })
      .catch((err) => { console.log(err); });
  }

  return (
    <>
      {userContext.user.role === "tippgeber" &&
        <Button
          variant="outlined"
          startIcon={<ContactMailIcon />}
          onClick={() => {
            setOpen(true);
          }}
        >
          Kreditantrag an Finanzierungsberater übertragen
        </Button>}
      {["administrator", "agent"].includes(userContext.user.role) && (<Button
        variant="outlined"
        startIcon={<ContactMailIcon />}
        onClick={() => {
          setOpen(true);
        }}
      >
        Berater zuweisen
      </Button>)}
      <Dialog
        onClose={() => { setOpen(false) }}
        open={open}
        fullWidth={true}
        maxWidth="sm">
        <DialogTitle>
          Finanzierungsberater auswählen
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Wähle den zuständigen Finanzierungsberater, bedenke allerdings, dass du nach der Übergabe keinen Zugriff mehr auf den Antrag haben wirst.
          </DialogContentText>
          <TextField
            label="Finanzierungsberater"
            value={selectedUser}
            fullWidth
            onChange={(e) => {
              setSelectedUser(e.target.value);
            }}
            select
          >
            {users.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={!selectedUser}
            onClick={() => {
              setCreditOwner(selectedUser);
            }}
            color="primary"
            variant="contained"
            autoFocus>
            Finanzierung weiterleiten
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
